export default __webpack_public_path__ + "static/media/about-12.44d7da9a.png";